import { PaddleEventData } from '@paddle/paddle-js';

export type CheckoutOwnerId = symbol;

type VisibilityListener = (
  transactionId: string,
  parkedEvents: PaddleEventData[]
) => void;

const MAX_PARKED_EVENTS_PER_TRANSACTION = 5;

let visibleTransactionId: string | null = null;
let visibleCheckoutOwnerId: CheckoutOwnerId | null = null;
const parkedEvents = new Map<string, PaddleEventData[]>();
const listeners = new Set<VisibilityListener>();

export const checkoutVisibilityStore = {
  getVisibleTransactionId(): string | null {
    return visibleTransactionId;
  },

  getVisibleOwnerId(): CheckoutOwnerId | null {
    return visibleCheckoutOwnerId;
  },

  isVisible(transactionId: string | null | undefined): boolean {
    return !!transactionId && transactionId === visibleTransactionId;
  },

  setVisibleTransaction(transactionId: string, ownerId: CheckoutOwnerId): void {
    visibleTransactionId = transactionId;
    visibleCheckoutOwnerId = ownerId;

    const events = parkedEvents.get(transactionId);
    parkedEvents.delete(transactionId);

    if (events?.length) {
      listeners.forEach((listener) => listener(transactionId, events));
    }
  },

  clearVisibleTransaction(transactionId?: string): void {
    if (transactionId && visibleTransactionId !== transactionId) {
      return;
    }

    visibleTransactionId = null;
    visibleCheckoutOwnerId = null;
  },

  parkEvent(transactionId: string, event: PaddleEventData): void {
    const existing = parkedEvents.get(transactionId) ?? [];
    parkedEvents.set(
      transactionId,
      [...existing, event].slice(-MAX_PARKED_EVENTS_PER_TRANSACTION)
    );
  },

  subscribe(listener: VisibilityListener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  clear(): void {
    visibleTransactionId = null;
    visibleCheckoutOwnerId = null;
    parkedEvents.clear();
  },
};
